<script>
	import { convert } from "src/services/helpers";

	export let row = {};
	export let key = "";
</script>

{convert(row[key])}
